import { useMemo } from 'react';

export function useMedicalReportDefaultData({
	isMeddiCase,
	defaultData,
	isConsentProvided,
}: {
	isMeddiCase: boolean;
	defaultData: Record<string, unknown> | undefined;
	isConsentProvided: boolean;
}) {
	const formDefaultData = useMemo(() => {
		return {
			...defaultData,
			addToPatientECard: isMeddiCase ?? isConsentProvided,
		};
	}, [defaultData, isMeddiCase, isConsentProvided]);

	return { formDefaultData };
}
